import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Chip, IconButton } from "@mui/material";
import { Popconfirm } from "antd";
import moment from "moment";
import { ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axios/axios-instance";
import Card from "../../components/common/Card";
import Fillter from "../../components/common/Fillter";
import MuiTable from "../../components/common/MuiTable";
import { useCountries } from "../../hooks/useCountries";
import { Column, SearchForm } from "../../utils/constants";
import { KeyValueObject } from "../../utils/models";
import { pathAPI } from "../../utils/pathApi";
import { formatNumber } from "../../utils/utils";
const UserApp = () => {
  const navigate = useNavigate();
  const [{ data: countries }] = useCountries();
  const { i18n, t } = useTranslation();
  const [data, setData] = useState<any[]>([]);
  const [loadingDelete, setLoadingDelete] = useState(false);
  var currentLang: any = localStorage.getItem("language");
  const [isLoading, setLoading] = useState(false);
  const [request, setRequest] = useState<SearchForm>({
    page: 0,
    size: 20,
    search: "",
    filter: "",
  });

  const countryData = countries?.map((item: any) => {
    return {
      key: item.code,
      value: item.name || (item.i18n_names?.[currentLang]) || item.code,
    };
  });

  const header: Column[] = [
    {
      id: "id",
      label: `${t("common.table.id")}`,
      minWidth: 10,
      align: "center",
    },
    {
      id: "full_name",
      label: `${t("common.table.name")}`,
      minWidth: 120,
      align: "center",
      format: (value) => {
        return <div className="whitespace-nowrap overflow-hidden truncate max-w-[120px]">{value}</div>
      }
    },
    {
      id: "email",
      label: `${t("common.table.email")}`,
      minWidth: 170,
      align: "center",
    },
    {
      id: "country",
      label: `${t("common.table.country")}`,
      minWidth: 100,
      align: "center",
      format: (value: any) => {
        return (
          <Chip label={value?.name ?? "-"} size="small" color="info" variant="outlined" />
        );
      },
    },
    {
      id: "phone_number",
      label: `${t("common.table.phone_number")}`,
      minWidth: 70,
      align: "center",
    },
    {
      id: "total_order",
      label: `${t("common.table.total_order")}`,
      minWidth: 10,
      align: "center",
      format: (value) => {
        return (
          <div className="font-bold">
            {formatNumber(value)}
          </div>
        );
      },
    },
    {
      id: "total_money",
      label: `${t("common.table.total_money")}`,
      minWidth: 20,
      align: "center",
      format: (value) => {
        return (
          <div className="font-bold">
            {formatNumber(value)}
          </div>
        );
      },
    },
    {
      id: "created_date",
      label: `${t("common.table.created_date")}`,
      minWidth: 20,
      align: "center",
      format: (value) => {
        return <div>{moment(value).format("YYYY/MM/DD HH:mm:ss")}</div>;
      },
    },
    {
      id: "action",
      label: `${t("common.table.actions")}`,
      minWidth: 100,
      align: "center",
      format: (id: number) => {
        return (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={2}
          >
            <Box
              size={"small"}
              component={IconButton}
              onClick={() => navigate(`${id}`)}
            >
              <EditIcon color="success" />
            </Box>
            <Popconfirm
              title={t("help_support.delete_text")}
              okText={t("btn.confirm")}
              cancelText={t("btn.cancel")}
              onConfirm={() => handleDeleteUser(id)}
              okButtonProps={{
                style: { background: "#ba2156", border: "none" },
                loading: loadingDelete,
              }}
            >
              <Box size={"small"} component={IconButton}>
                <DeleteIcon color={"error"} />
              </Box>
            </Popconfirm>
          </Box>
        );
      },
    },
  ];

  const handleOnChangeCountry = (e: KeyValueObject | null) => {
    const countryData = e ? e.key : "";
    setRequest((previousRequest) => ({
      ...previousRequest,
      countryId: countryData,
    }));
  };

  const handleChangeSearch = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRequest((previousRequest) => ({
        ...previousRequest,
        search: e.target.value,
      }));
  };

  const loadTableData = async () => {
    setLoading(true);
    await axiosInstance
      .get(pathAPI.appUsers, { params: request })
      .then((res: any) => {
        const endData = res.data.data.map((item: any) => ({
          ...item,
          action: item.id,
        }));
        setLoading(false);
        setData(endData);
      })
      .catch((err: any) => {
        console.log("====== reload data table error: ", err);
        setLoading(false);
        setData([]);
      });
  };

  const handleDeleteUser = async (id: number) => {
    await axiosInstance
      .delete(`${pathAPI.appUsers}/${id}`)
      .then((res: any) => {
        console.log("=== delete user: ", res);
        loadTableData();
      })
      .catch((err: any) => {
        console.log("====== reload data table error: ", err);
      });
  };

  useEffect(() => {
    loadTableData();
  }, []);

  return (
    <Card className="user-app">
      <Fillter
        inputPlaceholder="Search by name or email"
        handleOnChangeDropDown={(value) => handleOnChangeCountry(value)}
        countryData={countryData}
        showCountryFilter={true}
        showSearchFilter={true}
        onChangeSearch={handleChangeSearch}
        showBtnSearch
        handleClickBtn={() => loadTableData()}
      ></Fillter>
      <MuiTable header={header} data={data} isLoading={isLoading}></MuiTable>
    </Card>
  );
};
export default UserApp;
